import { Flex, Tooltip } from '@gmg/gmg-react-components';
import { FunctionComponent, SVGProps } from 'react';
import { ModuleId, modules } from 'src/graphql/mappers/module';
import LogoColorCard from '../../assets/svg/modul_iconGrey_ColorCard.svg';
import LogoAdobePhotoShop from '../../assets/svg/modul_iconGrey_Plugin_Ps.svg';
import LogoAdobeIllustrator from '../../assets/svg/modul_iconGrey_Plugin_Ai.svg';
import LogoCPGO from '../../assets/svg/modul_iconGrey_ColorProofGo.svg';
import LogoMeasure from '../../assets/svg/modul_iconGrey_Measure.svg';
import LogoOptimize from '../../assets/svg/modul_iconGrey_Optimize.svg';

export interface IconDisplayerProps {
    moduleIds: Array<ModuleId>;
    size: number;
};

const idToIconDef = new Map<ModuleId, { getLogo: (sizes: SVGProps<SVGSVGElement>) => JSX.Element; moduleName: string }>([
    ['5', { getLogo: (sizes) => <LogoCPGO {...sizes} />, moduleName: modules.get('5')! }],
    ['9', { getLogo: (sizes) => <LogoOptimize {...sizes} />, moduleName: modules.get('9')! }],
    ['10', { getLogo: (sizes) => <LogoMeasure {...sizes} />, moduleName: modules.get('10')! }],
    ['20', { getLogo: (sizes) => <LogoColorCard {...sizes} />, moduleName: modules.get('20')! }],
    ['30', { getLogo: (sizes) => <LogoAdobeIllustrator {...sizes} />, moduleName: modules.get('30')! }],
    ['40', { getLogo: (sizes) => <LogoAdobePhotoShop {...sizes} />, moduleName: modules.get('40')! }],
    ['41', { getLogo: (sizes) => <LogoAdobePhotoShop {...sizes} />, moduleName: modules.get('41')! }],
    ['42', { getLogo: (sizes) => <LogoAdobePhotoShop {...sizes} />, moduleName: modules.get('42')! }],
]);

const IconDisplayer: FunctionComponent<IconDisplayerProps> = (props) => {

    const sizes: SVGProps<SVGSVGElement> = { width: props.size, height: props.size };
    const icons = Array
        .from(new Set(props.moduleIds))
        .map(id => idToIconDef.get(id)!);

    return (
        <Flex gap='8px'>
            {icons.map(({ getLogo, moduleName }) =>
                <Tooltip message={moduleName} key={moduleName}>
                    <span aria-label={`${moduleName} Logo`}>{getLogo(sizes)}</span>
                </Tooltip>,
            )}
        </Flex>
    );
};

export default IconDisplayer;